import * as React from 'react';
// @ts-ignore
import AddGroupOwnerModal from './AddGroupOwnerModal';
import Button from 'components/ButtonDeprecated';
import ConfirmDialog from 'components/ConfirmDialog';
// @ts-ignore
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import GroupMemberships from 'collections/GroupMemberships';
// @ts-ignore
import GroupActions from 'groups/actions/GroupActions';
import GroupMemberListItem from './GroupMemberListItem';
import Link from 'components/Link';
// @ts-ignore
import ModalTrigger from 'components/ModalTrigger';
// @ts-ignore
import ScrollableArea from 'components/ScrollableArea';
import Text from 'components/Text';
import ToastActions from 'actions/ToastActions';

import './styles/GroupMemberList.scss';

type Props = {
  group: Group;
  onRequestHide: Function;
  onChange?: () => void;
  className?: string;
};

export default class GroupMemberList extends React.Component<Props> {
  getAddOwnerModal() {
    const { group, onChange } = this.props;
    return <AddGroupOwnerModal group={group} onFinish={onChange} />;
  }

  renderClassOwner(member: GroupMembership) {
    return (
      <GroupMemberListItem
        key={member.id}
        className="GroupMemberList-listItem"
        classMember={member}
        owner={member.isOwner()}
      />
    );
  }

  renderConfirmResignationDialog() {
    const onConfirm = () => {
      this.props.onRequestHide();
      GroupActions.resignOwnership(this.props.group).then(
        () => {
          ToastActions.showSuccessToast('Removed as class owner.');
          this.context.router.push('/classes');
        },
        () => {
          ToastActions.showDefaultErrorToast();
        }
      );
    };

    return (
      <ConfirmDialog
        eventScreenName="GroupMemberList"
        title="Are you sure you want to remove yourself as class owner?"
        subtext="Once you remove yourself as class owner, another owner will need to add you again."
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        onConfirm={onConfirm}
      />
    );
  }

  renderAddOwnerLink() {
    return (
      <li className="GroupMemberListItem">
        <ModalTrigger modal={this.getAddOwnerModal()}>
          <Link
            className="GroupMemberListItem-addOwnerLink"
            eventElementName="GroupMemberListItem-addOwnerLink">
            <Text weight="semibold">Add class owner</Text>
          </Link>
        </ModalTrigger>
      </li>
    );
  }

  renderFooter() {
    const userId = CurrentUser.getUser().id;
    const { group } = this.props;
    const isOwner = group.isOwnedByUser(userId);

    return (
      isOwner &&
      group.getOwners().length > 1 && (
        <div className="GroupMemberList-footer">
          <ModalTrigger modal={this.renderConfirmResignationDialog()}>
            <Button
              className="GroupMemberList-resignButton"
              level="secondary"
              color="apple"
              size="small"
              eventElementName="GroupMemberList-resignButton">
              Remove me as class owner
            </Button>
          </ModalTrigger>
        </div>
      )
    );
  }

  renderClassOwners() {
    const { group } = this.props;

    return (
      <ScrollableArea>
        <ul className="GroupMemberList-list">
          {(group.getOwners() as GroupMemberships).map(this.renderClassOwner)}
          {this.renderAddOwnerLink()}
        </ul>
      </ScrollableArea>
    );
  }

  render() {
    return (
      <div className="GroupMemberList">
        {this.renderClassOwners()}
        {this.renderFooter()}
      </div>
    );
  }
}
